import {
  REDUX_ACTIONS,
  GAME_ID,
} from '../../data/planTorresConstants';

const initialState = {
  // array filled with target words initially (all target words related to current level)
  tower: [],
  // array with indexes of unlocked toppers, by default contains 0 - index of flag topper, it's always available
  unlockedToppers: [],
  // list of toppers placeholders
  topperPlaceholders: [],
  // index of topper selected by user on feedback screen
  selectedTopperId: null,
};

const planTorresFeedbackReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_FEEDBACK_ROUND: {
      const { tower, defaultTopperId, topperPlaceholders } = action.payload;

      return {
        ...initialState,
        tower,
        unlockedToppers: [defaultTopperId],
        topperPlaceholders,
      };
    }
    case REDUX_ACTIONS.SELECT_TOPPER: {
      return {
        ...state,
        selectedTopperId: action.payload,
      };
    }
    case REDUX_ACTIONS.UNLOCK_TOPPER: {
      const topperId = action.payload;

      return {
        ...state,
        unlockedToppers: [...state.unlockedToppers, topperId],
      };
    }
    default:
      return state;
  }
};

export default planTorresFeedbackReducer;
